'use es6';

import fromRefinementFilter from './fromRefinementFilter';
const tryAddRefinement = (operator, field, filter) => {
  const refinement = fromRefinementFilter(field, filter);
  return refinement ? operator.set('refinement', refinement) : operator;
};
const fromPageViewOperation = (Operator, field, filter) => {
  const operator = Operator.of(field, filter.pageUrl);
  return tryAddRefinement(operator, field, filter);
};
export { fromPageViewOperation };